import RealEstateListing from '4-sections/RealEstateListing/RealEstateListing';
import ComponentInit from './utils/ComponentInit';

const componentList = { RealEstateListing };

export default ComponentInit(componentList);
